export function removeDecimalPoint(value: string | number): string {
	const valueNumber = Number(value);
	const valueInCents = Math.round(valueNumber * 100);
	return String(valueInCents);
}
